module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-16.04031677.jpg";